import PropTypes from 'prop-types';

const SeparatorTitle = ({ children }) => (
  <h2 className="separator text-xl p-2 mb-4 rounded text-separator-text bg-separator">
    {children}
  </h2>
);

SeparatorTitle.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SeparatorTitle;
